import { SvgIcon, SvgIconProps } from "@mui/material";

const LogomarkIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.209 11.9179C20.209 16.4969 16.4969 20.209 11.9179 20.209C7.33889 20.209 3.62687 16.4969 3.62687 11.9179C3.62687 7.33889 7.33889 3.62687 11.9179 3.62687C16.4969 3.62687 20.209 7.33889 20.209 11.9179ZM11.9179 18.2388C15.4088 18.2388 18.2388 15.4088 18.2388 11.9179C18.2388 8.42698 15.4088 5.59701 11.9179 5.59701C8.42698 5.59701 5.59701 8.42698 5.59701 11.9179C5.59701 15.4088 8.42698 18.2388 11.9179 18.2388Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31397 12.813C9.70085 13.8784 10.7221 14.6369 11.9179 14.6369C13.1138 14.6369 14.135 13.8784 14.5218 12.813L16.3737 13.4855C15.713 15.3049 13.9688 16.607 11.9179 16.607C9.86706 16.607 8.12286 15.3049 7.46215 13.4855L9.31397 12.813Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0299 20.3731V17.0896H23V20.3731C23 21.8239 21.8239 23 20.3731 23H17.0896V21.0299H20.3731C20.7358 21.0299 21.0299 20.7358 21.0299 20.3731Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.97015 3.62687V6.91045H1V3.62687C1 2.17609 2.17609 1 3.62687 1H6.91045V2.97015H3.62687C3.26417 2.97015 2.97015 3.26417 2.97015 3.62687Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default LogomarkIcon;
